module.exports = __webpack_public_path__ + "img/nvim.cd10314b.png";